import { render, staticRenderFns } from "./attendee-data.vue?vue&type=template&id=3695ac6e&scoped=true"
import script from "./attendee-data.vue?vue&type=script&lang=js"
export * from "./attendee-data.vue?vue&type=script&lang=js"
import style0 from "./attendee-data.vue?vue&type=style&index=0&id=3695ac6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695ac6e",
  null
  
)

export default component.exports